<template>
  <div class="counter-container">
    <div class="reduce" :class="{ on: number > minNum }" @click="reduce">-</div>
    <div class="number">
      <input
        type="number"
        v-model="number"
        @input="handleInput"
        @blur="handleBlur"
      />
    </div>
    <div class="plus" :class="{ on: number < maxNum }" @click="plus">+</div>
  </div>
</template>

<script>
export default {
  name: "Counter",
  model: {
    event: "changeNumber",
    prop: "number"
  },
  props: {
    maxNum: {
      type: Number,
      default: 9999
    },
    minNum: {
      type: Number,
      default: 1
    },
    number: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {};
  },
  methods: {
    plus() {
      if (this.number >= this.maxNum) {
        this.$dialog.toast({ mes: "最大数量为" + this.maxNum });
        this.number = this.maxNum;
        return false;
      }
      this.number++;
      this.emitEvent();
    },
    reduce() {
      if (this.number <= this.minNum) {
        this.$dialog.toast({ mes: "最小数量为" + this.minNum });
        this.number = this.minNum;
        return false;
      }
      this.number--;
      this.emitEvent();
    },
    handleInput() {
      this.checkNumber();
      this.emitEvent();
    },
    handleBlur() {
      this.checkNumber();
      this.emitEvent();
    },
    checkNumber() {
      if (this.number <= this.minNum) {
        this.$dialog.toast({ mes: "最小数量为" + this.minNum });
        this.number = this.minNum;
        return false;
      }
      if (this.number >= this.maxNum) {
        this.$dialog.toast({ mes: "最大数量为" + this.maxNum });
        this.number = this.maxNum;
        return false;
      }
      return true;
    },
    emitEvent() {
      this.$nextTick(() => {
        this.$emit("changeNumber", this.number);
      });
    }
  }
};
</script>

<style scoped lang="scss">
.counter-container {
  width: 1.8rem;
  height: 0.3rem;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  .reduce,
  .plus {
    border: 1px solid #e3e3e3;
    color: #e3e3e3;
    width: 0.6rem;
    height: 0.44rem;
    line-height: 0.44rem;
    text-align: center;
  }
  .reduce {
    border-right: none;
  }
  .plus {
    border-left: none;
  }
  .reduce.on,
  .plus.on {
    border-color: #a4a4a4;
    color: #a4a4a4;
  }
  .number {
    border: 1px solid #a4a4a4;
    color: #333;
    width: 0.6rem;
    height: 0.44rem;
    font-size: 0.28rem;
    line-height: 0.44rem;
    input {
      width: 100%;
      text-align: center;
    }
  }
}
</style>
